<h1 class="dialog-title" mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  <p [innerHtml]="data.message"></p>
</div>
<div  mat-dialog-actions align="center">
  <button mat-stroked-button (click)="onNoClick()">Não</button>
  <button class="dialog-button-confirm" mat-stroked-button color="primary" (click)="onYesClick()">Sim</button>
</div>